import { stringify } from '@liveblocks/core';

function memoize(fn) {
  const cache = /* @__PURE__ */ new Map();
  return (...args) => {
    const key = JSON.stringify(args.map((arg) => stringify(arg)));
    if (cache.has(key)) {
      return cache.get(key);
    }
    const result = fn(...args);
    cache.set(key, result);
    return result;
  };
}

export { memoize };
//# sourceMappingURL=memoize.mjs.map
